import Decimal from 'decimal.js';

export function getDiscountedValue(
  currentValue: Decimal | null | undefined,
  taxDiscount: Decimal | null | undefined
): Decimal | null {
  if (!currentValue) return null;

  if (!taxDiscount) return currentValue;

  const discountPercentage = taxDiscount.dividedBy(100);

  const remainingRatio = new Decimal(1).minus(discountPercentage);

  return currentValue.times(remainingRatio);
}
